import moment from 'moment';

class ComplementoDonatariasInputPipe {

  getName() {
    return 'Donatarias';
  }

  apply(data, comprobante) {
    const { Complemento } = data;

    if (!Complemento || !Complemento.Donatarias) {
      return data;
    }

    const { Donatarias } = Complemento;

    data.Complemento.Donatarias = {
      ...Donatarias,
      fechaAutorizacion : moment(Donatarias.fechaAutorizacion).toDate(),
    }

    return data;
  }

}

export default ComplementoDonatariasInputPipe;